import { render } from "./BaseImage.vue?vue&type=template&id=02ad739c&scoped=true"
import script from "./BaseImage.vue?vue&type=script&lang=ts"
export * from "./BaseImage.vue?vue&type=script&lang=ts"

import "./BaseImage.vue?vue&type=style&index=0&id=02ad739c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-02ad739c"

export default script